import React from "react";
import ServiceCard from "../components/ServicesCard";
import "../components/ServicesPage.css";
import bg from '../image/servises1.jpeg'
import ser1 from '../image/Lag.png'
import ser2 from '../image/ser2.png'
import ser3 from '../image/ser3.jpg'
import ser4 from '../image/ser4.png'
import ser5 from '../image/ser5.png'
import ser6 from '../image/ser6.png'
import ser7 from '../image/ser7.png'
import ser8 from '../image/ser8.png'
import Header from "../Header";
import Footer from "../Footer";
import ScrollButtons from "../ScrollButtons";


// Data for services
const services = [
  {
    title: " Luxury Accommodation",
    description: "Discover unparalleled comfort in our luxury accommodations, where every detail is crafted to perfection. Enjoy spacious rooms with elegant decor, plush bedding, and modern amenities, including high-speed Wi-Fi, smart TVs, and personalized services.",
    image: ser1,
  },
  {
    title: "Event Management",
    description: "Turn your special moments into unforgettable memories with our professional event management services. From meticulously planned weddings to high-profile corporate meetings, we handle everything—venue selection, decor, catering, and logistics.",
    image:ser2,
  },
  {
    title: "Fine Dining",
    description:
      "Savor a symphony of flavors with our fine dining experience, where gourmet cuisine meets impeccable service. Our award-winning chefs create masterpieces using the freshest ingredients, paired with an extensive selection of wines and beverages. ",
    image: ser3,
  },
  {
    title: "Travel Assistance",
    description:
      "Explore the world effortlessly with our comprehensive travel assistance. We provide end-to-end support, including ticket bookings, airport transfers, local transportation, and curated sightseeing tours.",
    image: ser4,
  },
  {
    title: "Swimming Pool & Fitness Center",
    description:  "Stay active and refreshed with access to our state-of-the-art fitness center and outdoor swimming pool. Our fully equipped gym offers a range of cardio and strength training equipment, while the pool is perfect for a relaxing swim or a quick dip to cool off.",
    image: ser5,
  },
  {
    title: "Business Services ",
    description:  "Our hotel offers a full range of business services designed to meet the needs of corporate travelers. Take advantage of our fully equipped meeting rooms, high-speed internet, and business support services such as printing, copying, and faxing. Our team can assist with arranging business events, conferences, or seminars, ensuring that everything runs smoothly. ",
    image: ser6,
  },
  {
    title: "Transportation & Shuttle Services",
    description: " you need an local transport to tourist attractions, or a private car for a business meeting, we offer convenient and comfortable transportation options. Our well-maintained fleet of vehicles is available 24/7, ensuring that you have access to safe and efficient transport throughout your stay.",
    image: ser7,
  },
  {
    title: "Nightlife & Entertainment",
    description:  "Many hotels offer evening entertainment such as live music, DJ nights, or themed events. Some luxury resorts also have in-house nightclubs or lounges.Why it's important: Provides guests with entertainment options on-site, ensuring they have a memorable stay even after the sun sets.",
    image: ser8,
  },
];

const ServicesPage = () => {
  return (

    <div>
        <Header/>
        <ScrollButtons/>
        <div className='cantainer-fluid'>
      <img src={bg} className=' bg img-fluid'/>
      <div className="text-overlay">
         <h3 style={{fontSize:'45px',paddingLeft:'45px'}}>Services</h3>
        Welcome to Our Hotel</div>
        </div>
    <div className="services-container">
      
      {services.map((service, index) => (
        <ServiceCard key={index} service={service} />
      ))}
    </div>
    <Footer/>
    </div>
  );
};

export default ServicesPage
